










































































































































































import { Component, Watch } from 'vue-property-decorator';
import {
  DateFilter,
  IPolicy,
  ITag,
  ITask,
  ITaskCountsResult,
  PolicyStatus,
  TaskStatus,
} from 'admiral-core';
import PoliciesOverview from '@/views/pages/policies/PoliciesOverview.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import StatisticCard from '@/components/common/StatisticCard.vue';
import { PolicyApi } from '@/services/PolicyApi';
import TaskOverview from '@/views/pages/tasks/TaskOverview.vue';
import CreatePolicyModal from '@/views/pages/policies/CreatePolicyModal.vue';
import NewPoliciesCard from '@/views/pages/start/NewPoliciesCard.vue';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import GoalRadialCard from '@/views/pages/start/GoalRadialCard.vue';
import { TaskApi } from '@/services/TaskApi';
import UpcomingTasksCard from '@/views/pages/start/UpcomingTasksCard.vue';
import UpcomingAntragsbuchCard from './start/UpcomingAntragsbuchCard.vue';
import { PlusIcon, CheckIcon, XIcon } from 'vue-feather-icons';
import NewTasksCard from '@/views/pages/start/NewTasksCard.vue';
import TopProductsCard from '@/views/pages/start/TopProductsCard.vue';
import { PreferencesAction } from '@/store/PreferencesModule';
import { PermissionMixin } from '@/mixins/PermissionMixin';

dayjs.locale('de');
dayjs.extend(isoWeek);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

@Component({
  components: {
    NewTasksCard,
    CreatePolicyModal,
    TaskOverview,
    StatisticCard,
    PoliciesOverview,
    NewPoliciesCard,
    GoalRadialCard,
    UpcomingTasksCard,
    UpcomingAntragsbuchCard,
    TopProductsCard,
    PlusIcon,
    CheckIcon,
    XIcon,
  },
})
export default class Start extends mixins(BaseMixin, PermissionMixin) {
  allLatestPolicies: IPolicy[] = [];
  allLatestAbPolicies: IPolicy[] = [];

  isLoading = false;
  tags: ITag[] = [];
  allTasks: ITask[] = [];
  isAdminMode = false;

  status: PolicyStatus[] = [
    PolicyStatus.PLANNED,
    PolicyStatus.OPEN,
    PolicyStatus.SUBMITTED,
    PolicyStatus.POLICED,
  ];

  allTaskCounts: ITaskCountsResult = {
    ALL: 0,
    COMPLETED: 0,
    ARCHIVED: 0,
    IMPORTANT: 0,
    TODO: 0,
    BACKOFFICE: 0,
  };

  async mounted() {
    try {
      if (this.isDarkMode) {
        document.body.classList.add('dark-layout');
      } else {
        document.body.classList.remove('dark-layout');
      }

      this.isAdminMode = this.$store.getters['PreferencesModule/isAdminMode'];
      await this.loadAllData();

      this.$root.$on('change-policy-filter', () => {
        this.loadLatestPolicies();
      });
      this.$root.$on('change-task-filter', () => {
        this.loadAllTasks();
        this.loadTaskCounts();
      });
    } catch (e) {
      console.log(e);
    }
  }
  get isDarkMode(): boolean {
    return this.$store.getters['PreferencesModule/isDarkMode'];
  }

  @Watch('status')
  async watchStatus() {
    await this.loadLatestPolicies();
  }

  handleUpdateStatus(status: PolicyStatus) {
    console.log(status);
  }

  async loadAllData() {
    await Promise.all([this.loadLatestPolicies(), this.loadAllTasks(), this.loadTaskCounts()]);
  }

  handleAdminModeChange() {
    this.$store.dispatch(
      `PreferencesModule/${PreferencesAction.updateAdminMode}`,
      this.isAdminMode,
    );
    this.loadTaskCounts();
    this.$forceUpdate();
  }

  get weeklyComparisonData() {
    const today = dayjs();
    const weekdayLabels = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

    const currentWeekStart = dayjs().startOf('isoWeek');
    const lastWeekStart = currentWeekStart.subtract(7, 'day');
    const lastWeekEnd = lastWeekStart.add(6, 'day');

    const initWeekData = () => ({
      neu: { quantity: Array(7).fill(0), value: Array(7).fill(0) },
      eingereicht: { quantity: Array(7).fill(0), value: Array(7).fill(0) },
      policiert: { quantity: Array(7).fill(0), value: Array(7).fill(0) },
    });
    const currentData = initWeekData();
    const lastData = initWeekData();

    this.filteredPolicies.forEach((policy) => {
      const createdDate = dayjs(policy.createdAt);
      if (
        createdDate.isSameOrAfter(currentWeekStart, 'day') &&
        createdDate.isSameOrBefore(today, 'day')
      ) {
        const idx = createdDate.isoWeekday() - 1;
        currentData.neu.quantity[idx] += policy.quantity;
        currentData.neu.value[idx] += policy.value;
      }
      if (
        createdDate.isSameOrAfter(lastWeekStart, 'day') &&
        createdDate.isSameOrBefore(lastWeekEnd, 'day')
      ) {
        const idx = createdDate.isoWeekday() - 1;
        lastData.neu.quantity[idx] += policy.quantity;
        lastData.neu.value[idx] += policy.value;
      }

      if (policy.policySteps && Array.isArray(policy.policySteps)) {
        policy.policySteps.forEach((step) => {
          if (step.title === 'Anbahnung eingereicht') {
            const stepDate = dayjs(step.updatedAt);
            if (
              stepDate.isSameOrAfter(currentWeekStart, 'day') &&
              stepDate.isSameOrBefore(today, 'day')
            ) {
              const idx = stepDate.isoWeekday() - 1;
              currentData.eingereicht.quantity[idx] += policy.quantity;
              currentData.eingereicht.value[idx] += policy.value;
            }
            if (
              stepDate.isSameOrAfter(lastWeekStart, 'day') &&
              stepDate.isSameOrBefore(lastWeekEnd, 'day')
            ) {
              const idx = stepDate.isoWeekday() - 1;
              lastData.eingereicht.quantity[idx] += policy.quantity;
              lastData.eingereicht.value[idx] += policy.value;
            }
          }
        });
      }

      if (policy.policedAt) {
        const policedDate = dayjs(policy.policedAt);
        if (
          policedDate.isSameOrAfter(currentWeekStart, 'day') &&
          policedDate.isSameOrBefore(today, 'day')
        ) {
          const idx = policedDate.isoWeekday() - 1;
          currentData.policiert.quantity[idx] += policy.quantity;
          currentData.policiert.value[idx] += policy.value;
        }
        if (
          policedDate.isSameOrAfter(lastWeekStart, 'day') &&
          policedDate.isSameOrBefore(lastWeekEnd, 'day')
        ) {
          const idx = policedDate.isoWeekday() - 1;
          lastData.policiert.quantity[idx] += policy.quantity;
          lastData.policiert.value[idx] += policy.value;
        }
      }
    });

    return {
      currentWeek: {
        days: weekdayLabels,
        ...currentData,
      },
      lastWeek: {
        days: weekdayLabels,
        ...lastData,
      },
    };
  }

  async loadLatestPolicies() {
    try {
      this.$Progress.start();
      this.isLoading = true;
      const allLatestPolicies = await PolicyApi.getPolicies({
        status: this.status,
        businessYear: new Date().getFullYear(),
        agency: this.user.agency,
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
        dateFilter: DateFilter.ALL,
      });

      this.allLatestPolicies = allLatestPolicies.data as IPolicy[];
      this.allLatestAbPolicies = this.allLatestPolicies.filter(
        (policy) => !!policy.antragsbuchData,
      );
      this.$Progress.finish();
      this.isLoading = false;
    } catch (e) {
      this.$toastr.e(
        'Beim Abrufen der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      this.isLoading = false;
      this.$Progress.finish();
      throw e;
    }
  }

  async loadAllTasks() {
    try {
      const showDemo = this.$store.getters['PreferencesModule/getShowDemo'];
      const response = await TaskApi.getTasks({
        status: [TaskStatus.TODO, TaskStatus.COMPLETED, TaskStatus.ARCHIVED],
        agency: this.user.agency,
        showDemo,
      });
      this.allTasks = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  async loadTaskCounts() {
    try {
      const showDemo = this.$store.getters['PreferencesModule/getShowDemo'];
      const response = await TaskApi.getTaskCounts({
        status: [],
        agency: this.user.agency,
        users: this.isAdminMode ? [] : [this.user],
        showDemo,
      });
      this.allTaskCounts = response.data;
    } catch (e) {
      console.error(e);
    }
  }

  get confirm() {
    return this.$route.params.confirm;
  }

  get filteredPolicies(): IPolicy[] {
    if (this.isAdminMode) {
      return this.allLatestPolicies;
    }
    return this.allLatestPolicies.filter((policy) => policy.user?.id === this.user.id);
  }

  get tasks(): ITask[] {
    if (this.isAdminMode) {
      return this.allTasks;
    }
    return this.allTasks.filter((task) => task.users.some((user) => user.id === this.user.id));
  }

  get latestPolicies(): IPolicy[] {
    if (this.isAdminMode) {
      return this.allLatestPolicies;
    }
    return this.allLatestPolicies.filter((policy) => policy.user?.id === this.user.id);
  }

  get latestAbPolicies(): IPolicy[] {
    if (this.isAdminMode) {
      return this.allLatestAbPolicies;
    }
    return this.allLatestAbPolicies.filter((policy) => policy.user?.id === this.user.id);
  }

  // async loadTags() {
  //   try {
  //     const response = await TagApi.getTags({
  //       agency: this.user.agency,
  //     });
  //     this.tags = response.data;
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }
}
